import { Button } from "@/app/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/app/components/ui/dialog";

interface SkipSectionDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	/** Called when the user confirms the skip. The dialog closes itself first. */
	onSkip: () => void;
	sectionTitle?: string;
}

/**
 * Controlled confirm dialog that replaces the Bootstrap `#skipSectionModal`
 * copies. Open state and the skip callback stay page-owned.
 */
function SkipSectionDialog({ open, onOpenChange, onSkip, sectionTitle }: SkipSectionDialogProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{sectionTitle ? `${sectionTitle} Not Completed` : "Section Not Completed"}</DialogTitle>
					<DialogDescription>
						You have not completed this section, Do you want to skip or stay to complete?
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button type="button" variant="secondary" onClick={() => onOpenChange(false)}>
						Stay
					</Button>
					<Button
						type="button"
						onClick={() => {
							onOpenChange(false);
							onSkip();
						}}
					>
						Skip
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default SkipSectionDialog;
